/**
 * Nests variations under the run they were generated from (parentRunId). Runs whose
 * parent is missing from the list, or that point at themselves, become roots. Order
 * within each level follows the input (oldest first).
 *
 * With `visibleIds`, only matching nodes and the ancestors that lead to them are kept;
 * those ancestors are flagged `isMuted` so the path stays readable without counting
 * as a match.
 * @param {Array<Object>} variations - Runs from useGetVariations
 * @param {Set<string>|null} visibleIds - Ids that pass the active filter, or null for all
 * @returns {Array<{ variation: Object, children: Array, isMuted: boolean }>}
 */
export const buildVariationTree = (variations, visibleIds = null) => {
  const nodes = new Map(variations.map(variation => [
    String(variation.id),
    { variation, children: [], isMuted: false },
  ]))
  const roots = []

  variations.forEach((variation) => {
    const id = String(variation.id)
    const parentId = variation.parentRunId == null ? null : String(variation.parentRunId)
    const parent = parentId !== id ? nodes.get(parentId) : null
    ;(parent ? parent.children : roots).push(nodes.get(id))
  })

  if (!visibleIds) {
    return roots
  }

  const prune = branch => branch.flatMap((node) => {
    const children = prune(node.children)
    const matches = visibleIds.has(String(node.variation.id))
    return matches || children.length > 0 ? [{ ...node, children, isMuted: !matches }] : []
  })

  return prune(roots)
}
